import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { connectHits } from "react-instantsearch-core";
import { Link } from "gatsby";
import { NoResultProperties } from '../queries/common_use_query';
import Cookies from 'universal-cookie';
import '../pages/property/assets/styles/_index.scss';
import $ from "jquery";
import { ShowProcessedImage } from '@Components/common/ggfx-client/module/components/show-image';
import imageConfig from "../../static/images/config.json";
import noImage from "../images/no-image.png";

const SearchBanner = (props) => {

    const [department, setDepartment] = useState('residential');

    useEffect(() => {
        props.department && setDepartment(props.department);
    }, [props.department]);

    const { loading: loading, error: error, data: data } = NoResultProperties(props.status, department);

    const mycookies = new Cookies();

    return (
        <Container>
            {data && data.properties.length > 0 &&
                <div className="no-results-page">
                    <div className="row h-100 align-items-center">
                        <div className="col-md-12">
                            <h5 className="text-center my-3">Unfortunately, we do not currently have any properties that match your search criteria. We have sold property with the criteria you have entered, please contact us for a valuation</h5>
                        </div>
                        <div className="col-md-12 mt-0">
                            <p className="text-center results-page-wrapper mb-5">In the meantime, we have selected some of our showcase properties for you to browse below. Alternatively, you can search again in the bar above.</p>

                            <Row>
                                {data.properties.map((hit, i) => {

                                    // console.log("xxxxxxxx", hit.id, hit.search_type)

                                    // property details url structure
                                    let uriStr = "";

                                    if (hit.search_type === "sales" && hit.department === "residential") {
                                        uriStr = `property-for-sale/`
                                    } else if (hit.search_type === "lettings" && hit.department === "residential") {
                                        uriStr = `property-to-rent/`
                                    }
                                    // property details url structure

                                    //property description
                                    let text_truncate = function (str, length, ending) {
                                        // 
                                        var $win = $(window);

                                        if ($win.width() <= 1500) {
                                            if (length == null) {
                                                length = 100;
                                            }
                                        } else if ($win.width() >= 1500) {
                                            if (length == null) {
                                                length = 200;
                                            }
                                        }
                                        // 

                                        if (ending == null) {
                                            ending = '...';
                                        }
                                        if (str.length > length) {
                                            return str.substring(0, length - ending.length) + ending;
                                        } else {
                                            return str;
                                        }
                                    };
                                    // property description

                                    // Book a viewing
                                    const bookViewing = (e, hit) => {
                                        const pageurl = window.location.hostname + "/" + uriStr + "-" + hit.slug + "-" + hit.id
                                        sessionStorage.setItem('data', JSON.stringify(hit))
                                        sessionStorage.setItem('property_url', pageurl)
                                    }
                                    // Book a viewing

                                    return (
                                        <>
                                            <div className="property-card d-md-flex flex-wrap mysingleproperty" key={i}
                                                id={`mySaleProp${hit.id}`}
                                                data-objectID={hit.id} data-lat={hit?._geoloc?.lat} data-lng={hit?._geoloc?.lng}>
                                                <div className="view-part1">
                                                    <div className="main-item">
                                                        {
                                                            hit.images && (hit.images.length > 0) ?
                                                                <div className="img-zoom">
                                                                    {hit.status === "Sold STC" ? <div className="sold-cls">Sold</div> : hit.status === "Sold" ? <div className="sold-cls">Sold</div> : null}
                                                                    <picture>
                                                                        <Link id={`mySaleProp${hit.id}`}
                                                                            onClick={() => mycookies.set('mySaleProp', hit.id, { path: '/', maxAge: 300 })}
                                                                            to={`/${uriStr}${hit.slug}-${hit.id}`}>
                                                                            <img src={hit.images[0].url} alt="" class="no-propery-img" />
                                                                            {/* <ShowProcessedImage images={hit.images[0]} attr={{ className: 'propery-img', alt: ''}} transforms={imageConfig.property.searchResults.sizes} /> */}
                                                                        </Link>
                                                                    </picture>
                                                                </div>
                                                                :
                                                                <img src={noImage} alt="" />
                                                        }
                                                    </div>
                                                </div>

                                                <div className="card-details text-left">
                                                    <Link id={`mySaleProp${hit.id}`}
                                                        onClick={() => mycookies.set('mySaleProp', hit.id, { path: '/', maxAge: 300 })}
                                                        to={`/${uriStr}${hit.slug}-${hit.id}`}>
                                                        <div className="detail-head d-flex align-items-center justify-content-between">
                                                            {hit.price ? <p className="price">&pound;{hit.price.toLocaleString()}</p> : ''}
                                                        </div>
                                                        {hit.title ? <h2 className="prop-title d-block"><Link id={`mySaleProp${hit.id}`}
                                                            onClick={() => mycookies.set('mySaleProp', hit.id, { path: '/', maxAge: 300 })}
                                                            to={`/${uriStr}${hit.slug}-${hit.id}`}>{hit.title}</Link></h2> : ''}
                                                        {hit.display_address ? <span className="address-title d-block">{hit.display_address}</span> : ''}
                                                        {hit.description ? <p className="prop-desc">{text_truncate(hit.description)}</p> : ''}
                                                    </Link>

                                                    <ul className="property-icons list-inline">
                                                        <li className="list-inline-item">
                                                            <Link to="/book-a-viewing" onClick={(e) => bookViewing(e, hit)} className="distance d-flex align-items-center"><i className="icon-date"></i> Book a viewing</Link>
                                                        </li>
                                                        {
                                                            hit.bedroom ?
                                                                <li className="list-inline-item">
                                                                    <span className="d-flex align-items-center property-bedwrap">
                                                                        <i className="bedroom-icon"></i> <span className="property-bedbath pl-3">{hit.bedroom} {hit.bedroom > 1 ? 'Bedrooms' : 'Bedroom'}</span>
                                                                    </span>
                                                                </li>
                                                                : ''
                                                        }
                                                        {
                                                            hit.bathroom ?
                                                                <li className="list-inline-item">
                                                                    <span className="d-flex align-items-center property-bedwrap">
                                                                        <i className="bathroom-icon"></i> <span className="property-bedbath pl-3">{hit.bathroom} {hit.bathroom > 1 ? 'Bathrooms' : 'Bathroom'}</span>
                                                                    </span>
                                                                </li>
                                                                : ''
                                                        }
                                                        {
                                                            hit.reception ?
                                                                <li className="list-inline-item">
                                                                    <span className="d-flex align-items-center property-bedwrap">
                                                                        <i className="reception-icon"></i> <span className="property-bedbath pl-3">{hit.reception} {hit.reception > 1 ? 'Receptions' : 'Reception'}</span>
                                                                    </span>
                                                                </li>
                                                                : ''
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })}
                            </Row>
                        </div>
                    </div>
                </div>
            }
        </Container >
    )
};
export default connectHits(SearchBanner)
